module.exports = __webpack_public_path__ + "img/album05_19.35c7f8ec.jpg";